import type { TOC } from '@ember/component/template-only'
import type StorylandsLessonsReRoute from 'teacher-ui-client/reporting/ui-scope/re/storylands/route'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { t } from 'ember-intl'
import ReportingDetailedControls from 'teacher-ui-client/components/reporting/detailed-controls'
import { not } from 'ember-truth-helpers'
import ReportingNoDataMessageIf from 'teacher-ui-client/components/reporting/no-data-message-if'
import StorylandsLessonsTotals from 'teacher-ui-client/components/giraffe/charts/storylands-lessons/totals'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'
import StorylandsLessonsHistory from 'teacher-ui-client/components/giraffe/charts/storylands-lessons/history'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import RouteTemplate from 'ember-route-template'

interface Signature {
  model: ModelFor<StorylandsLessonsReRoute>
}

export const ReStorylandsLessons: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.storylands"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.storylandsTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.storylandsTotals}}>
    {{#each @model.storylandsTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <StorylandsLessonsTotals
          @data={{gradeData}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.storylandsTotals"}}
          @title={{t "reporting.chartTitles.storylandsTotals"}}
          @summaryTitle={{t "reporting.summaryTitles.storylandsTotals.heading"}}
        />
      </div>
    {{/each}}

    {{#if @model.storylandsHistory}}
      <StorylandsLessonsHistory
        @uiScope={{@model.uiScope.scope}}
        @students={{@model.scopedStudents}}
        @data={{@model.storylandsHistory}}
        @themeKey={{ThemeKeys.orange}}
        @studentRouteName="reporting.ui-scope.re.student-summary"
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReStorylandsLessons)
